import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { AccountService } from 'app/shared/services/account/account.service';
import { MessageConstant} from 'app/shared/utils/message.constant';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector     : 'forgot-password',
    templateUrl  : './forgot-password.component.html',
    styleUrls    : ['./forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class ForgotPasswordComponent implements OnInit
{
    forgotPasswordForm: FormGroup;
    reactiveFormOTP: FormGroup;
    reactiveFormPassword:FormGroup;
    options:any;
    otpScreen = false;
    mobileScreen = true;
    newPasswordScreen = false;
    isPasswordFieldType: boolean;
    isPasswordConfirmFieldType: boolean;
    logs:any;
    userid:any;
    registerdmobile:any;
    isErrorMessage = false;
    errorMessage = "";
    isSuccessMessage = false;
    successMessage ="";
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(private accountService: AccountService,private router: Router,
        private _fuseConfigService: FuseConfigService,private snackBar: MatSnackBar,
        private _formBuilder: FormBuilder
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.forgotPasswordForm = this._formBuilder.group({
            mobile: ['', [Validators.required,Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]]
        });
        this.reactiveFormOTP = this._formBuilder.group({
      
            otp: ['', [Validators.required]],
            
          });
          this.reactiveFormPassword = this._formBuilder.group({
           
            password: ['', [Validators.required]],
            c_password: ['', [this.confirmValidator]],
            
          });
    }
    mobilePassword(){
        if(this.forgotPasswordForm.valid){
          
          
          let formValues = this.forgotPasswordForm.value;
          let params = {
            mobile: formValues.mobile,
            otp_purpose : "FORGOT_PASSWORD"
          }
          //
          this.accountService.getotpNew(params).subscribe((resp:any)=>{
            //
            if(resp.status == true){
              this.logs = resp;
              this.successMessage = MessageConstant.userOTPSend;
              this.isSuccessMessage = true;
              setTimeout(() => {                           //<<<---using ()=> syntax
              this.isSuccessMessage = false;
              }, 3000);
              //this.snackBar.open(MessageConstant.userOTPSend, 'Dismiss', { duration: 3000 });
              this.mobileScreen = false;
              this.otpScreen = true;
            }else{
              this.errorMessage = MessageConstant.validRegNumber;
                        this.isErrorMessage = true;
                        setTimeout(() => {                           //<<<---using ()=> syntax
                        this.isErrorMessage = false;
                      }, 3000);
              //this.snackBar.open(MessageConstant.validRegNumber, 'Dismiss', { duration: 3000 });
            }
            
           },(err)=>{
            this.errorMessage = MessageConstant.errorMessage;
            this.isErrorMessage = true;
            setTimeout(() => {                           //<<<---using ()=> syntax
            this.isErrorMessage = false;
          }, 3000);
           //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
           
        })
         }else{
          this.errorMessage = MessageConstant.validRegNumber;
          this.isErrorMessage = true;
          setTimeout(() => {                           //<<<---using ()=> syntax
          this.isErrorMessage = false;
        }, 3000);
          //this.snackBar.open(MessageConstant.validRegNumber, 'Dismiss', { duration: 5000 });
        }
      }
      otpSubmit(){
        if(this.reactiveFormOTP.valid){
         
          let formValues = this.reactiveFormOTP.value;
          let formMobileValues = this.forgotPasswordForm.value;
          let params = {
            username:"xyz",
            email:"xyz",
            otp: formValues.otp,
            mobile: formMobileValues.mobile,
            otp_purpose : "FORGOT_PASSWORD"
          }
          //
          this.accountService.verifyOTPNew(params).subscribe((res:any)=>{
            //
            if(res.status){
              this.logs = res;
              this.userid= res.data[0].user_id;
              this.successMessage = res.message;
              this.isSuccessMessage = true;
              setTimeout(() => {                           //<<<---using ()=> syntax
              this.isSuccessMessage = false;
              }, 3000);
            //this.snackBar.open(res.message, 'Dismiss', { duration: 3000 });
             this.otpScreen = false;
             this.newPasswordScreen = true;
            }else{
              this.errorMessage = MessageConstant.errorOTP;
              this.isErrorMessage = true;
              setTimeout(() => {                           //<<<---using ()=> syntax
              this.isErrorMessage = false;
            }, 3000);
              //this.snackBar.open(MessageConstant.errorOTP, 'Dismiss', { duration: 3000 });
            }
            
           },(err)=>{
            this.errorMessage = MessageConstant.errorMessage;
            this.isErrorMessage = true;
            setTimeout(() => {                           //<<<---using ()=> syntax
            this.isErrorMessage = false;
          }, 3000);
            //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
           this.router.navigateByUrl('/forgotpassword');   
        })
    
    
        }else{
          this.errorMessage = MessageConstant.validOTPError;
            this.isErrorMessage = true;
            setTimeout(() => {                           //<<<---using ()=> syntax
            this.isErrorMessage = false;
          }, 3000);
          //this.snackBar.open(MessageConstant.validOTPError, 'Dismiss', { duration: 5000 });
        }
      }
      confirmValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
          return { error: true, required: true };
        } else if (control.value !== this.reactiveFormPassword.controls.password.value) {
          return { error: true, confirm: true };
        }
      }
      togglePasswordFieldType(){
        this.isPasswordFieldType = !this.isPasswordFieldType;
      }
      togglePasswordConfirmFieldType(){
        this.isPasswordConfirmFieldType = !this.isPasswordConfirmFieldType;
      }
      submit(){
        if(this.reactiveFormPassword.valid){
         
          let formValues = this.reactiveFormPassword.value;
          let formMobileValues = this.forgotPasswordForm.value;
          let params = {
            id:this.userid,
            password: formValues.c_password,
            registration_origin: "WEB",
            modify_by: this.userid
           
          }
          //
          this.accountService.updatePassword(params).subscribe((res:any)=>{
            //
            this.logs = res;
              //this.snackBar.open(res.message, 'Dismiss', { duration: 3000 });
              this.successMessage = res.message;
              this.isSuccessMessage = true;
              setTimeout(() => {                           //<<<---using ()=> syntax
              this.isSuccessMessage = false;
              }, 3000);
              this.otpScreen = false;
              this.newPasswordScreen = true;
              this.router.navigateByUrl('/login'); 
           },(err)=>{
            this.errorMessage = MessageConstant.errorMessage;
            this.isErrorMessage = true;
            setTimeout(() => {                           //<<<---using ()=> syntax
            this.isErrorMessage = false;
          }, 3000);
            //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
           this.router.navigateByUrl('/login');   
        })
    
    
        }else{
          this.errorMessage = MessageConstant.validOTPError;
            this.isErrorMessage = true;
            setTimeout(() => {                           //<<<---using ()=> syntax
            this.isErrorMessage = false;
          }, 3000);
          //this.snackBar.open(MessageConstant.validOTPError, 'Dismiss', { duration: 5000 });
        }
      }
      resendOTP(){
       // this.router.navigateByUrl('/forgetpassword');
       // let formValues = this.reactiveFormPassword.value;
        let formMobileValues = this.forgotPasswordForm.value;
        let params = {
          mobile :   formMobileValues.mobile ,
          email : null,
          username:null,
          id:null,
          otp_purpose : "FORGOT_PASSWORD"
        }
        this.accountService.getotpNew(params).subscribe((res:any)=>{
          this.logs = res;
          this.successMessage = MessageConstant.getOTPMessage;
          this.isSuccessMessage = true;
          setTimeout(() => {                           //<<<---using ()=> syntax
          this.isSuccessMessage = false;
          }, 3000);
       
            //this.snackBar.open(MessageConstant.getOTPMessage, 'Dismiss', { duration: 3000 });
         },(err)=>{
          this.errorMessage = MessageConstant.errorMessage;
          this.isErrorMessage = true;
          setTimeout(() => {                           //<<<---using ()=> syntax
          this.isErrorMessage = false;
        }, 3000);
          //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
          //this.router.navigateByUrl('/register');   
      })
      }
}
